export default "__VITE_ASSET__s80AM3vY__"